import { api } from './api'

// The level-0 item of every standard: [{ _id, label, standard }].
// `label` and `standard` are the same string; use `standard` as the value.
export function listStandards() {
  return api.get('/items/standards').then((data) => data.standards)
}

// The distinct textType values across items (strings), for the text-type filter.
export function listTextTypes() {
  return api.get('/items/texttypes').then((data) => data.textTypes)
}

// Every item of a standard (including the level-0 root), in reading order:
// [{ _id, order, level, label, authors, path }].
export function listItemsByStandard(standard) {
  return api
    .get(`/items?standard=${encodeURIComponent(standard)}`)
    .then((data) => data.items)
}

// Items matching the chosen facets. `payload` = { standards, chapters, authors,
// textTypes, op }, where op is 'and' | 'or'. Resolves to item objects.
export function filterItems(payload) {
  return api.post('/items/filter', payload).then((data) => data.items)
}
